import InnerLayout from './InnerLayout';
export default InnerLayout;
